export class IosAppStore {
  public static readonly APPSTORE: string = "appstore";

  readonly id: string;
}
